import * as React from 'react';

const LeftArrow = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.80054 12.5998L1.20054 6.99976L6.80054 1.39976"
      stroke="#4FADA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LeftArrow;
